import { useContext } from "react"
import { ConfiguracaoFormasDePagamentoContext } from "./ConfiguracaoFormasDePagamentoContext"

export function useConfiguracaoFormasDePagamentoContext() {
    return useContext(ConfiguracaoFormasDePagamentoContext)
}
